// Get Company's logo or avatar
import { ENDPOINT_ROOT, ENDPOINT_USERS } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getImageToBase64 = ({ queryKey: [endpoint] }) =>
  axiosAuth
    .get(`${ENDPOINT_ROOT}/${ENDPOINT_USERS}/${endpoint}`, {
      responseType: 'arraybuffer',
    })
    .then((res) => {
      const imageType = res.headers['content-type'];
      const imageBuffer = Buffer.from(res.data, 'binary').toString('base64');

      return `data:${imageType};base64, ${imageBuffer}`;
    });

export default getImageToBase64;
